/**
 * Utilitário centralizado para construção de URLs.
 * Facilita migração futura de id → username nas rotas.
 */

/**
 * Retorna o path relativo para a página pública do torneio.
 * @param torneioId - ID do torneio
 * @param username - Username do torneio (futuro)
 * @throws Error se torneioId for vazio
 */
export function buildTournamentPath(torneioId: string, username?: string): string {
  if (!torneioId || torneioId.trim() === '') {
    throw new Error('torneioId é obrigatório para construir URL do torneio');
  }
  // TODO: Migrar para username quando implementado
  // if (username) return `/tournament/@${username}`;
  return `/tournamentsingle/${torneioId}`;
}

/**
 * Retorna a URL absoluta para a página pública do torneio.
 * @param torneioId - ID do torneio
 * @param username - Username do torneio (futuro)
 */
export function buildTournamentPublicUrl(torneioId: string, username?: string): string {
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  return `${origin}${buildTournamentPath(torneioId, username)}`;
}

/**
 * Retorna o path relativo para a página pública de um post.
 * @param postId - ID do post
 * @throws Error se postId for vazio
 */
export function buildPostPath(postId: string): string {
  if (!postId || postId.trim() === '') {
    throw new Error('postId é obrigatório para construir URL do post');
  }
  return `/post/${postId}`;
}

/**
 * Retorna a URL absoluta para a página pública de um post.
 * @param postId - ID do post
 */
export function buildPostPublicUrl(postId: string): string {
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  return `${origin}${buildPostPath(postId)}`;
}
